import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';
import { firstValueFrom } from 'rxjs';
import { getAccessibleIconColor } from '../../utils/contrast-color.util';

const MAX_RESULTS = 240;

/** Durchsuchbare Auswahl eines RemixIcon-Icons aus dem gesamten RemixIcon-Fundus
 * (assets/remix-icons.json, aus dem installierten remixicon-Paket generiert) — ersetzt für
 * das Kachel-Icon die frühere Bild-URL/Upload/KI-Generierung, da das Icon jetzt eine reine
 * Icon-Font-Glyphe (`ri-*`-Klasse) statt eines Bildes ist. */
@Component({
    selector: 'app-tile-icon-picker',
    standalone: true,
    imports: [CommonModule, FormsModule, DialogModule],
    templateUrl: './tile-icon-picker.component.html',
    styleUrls: ['./tile-icon-picker.component.scss']
})
export class TileIconPickerComponent implements OnInit {
    @Input() public visible = false;
    @Output() public visibleChange = new EventEmitter<boolean>();
    /** Akzentfarbe der Kachel — nur für die Kontrast-Vorschau der Icons in der Liste. */
    @Input() public color = '#6366f1';
    @Output() public accepted = new EventEmitter<string>();

    public search = '';
    public filteredIcons: string[] = [];
    private allIcons: string[] = [];

    constructor(private http: HttpClient) { }

    public async ngOnInit(): Promise<void> {
        this.allIcons = await firstValueFrom(this.http.get<string[]>('assets/remix-icons.json'));
        this.updateFiltered();
    }

    public get iconColor(): string {
        return getAccessibleIconColor(this.color);
    }

    public onSearchChange(): void {
        this.updateFiltered();
    }

    public select(name: string): void {
        this.accepted.emit(`ri-${name}`);
        this.close();
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(false);
        this.search = '';
        this.updateFiltered();
    }

    private updateFiltered(): void {
        const term = this.search.trim().toLowerCase();
        const matches = term ? this.allIcons.filter((name) => name.includes(term)) : this.allIcons;
        this.filteredIcons = matches.slice(0, MAX_RESULTS);
    }
}
